module.exports = __webpack_public_path__ + "img/1517271868.1190ac32.jpg";